<script>
export default {
  name: "setting",
  provide() {
    return { modalData: this.modalData };
  },
  data() {
    return {
      modalData: {},
      form: {}
    };
  },
  methods: {
    //表格序号，根据索引+1
    indexMethod(index) {
      return index + 1;
    },
    setPersonnel(row) {
      Object.assign(this.modalData, row || {});
      this.$refs.setPersonnelModal.open("销售总监人员设置");
    },
    setPerformance(row) {
      Object.assign(this.modalData, row || {});
      this.$refs.setPerformanceModal.open("销售经理绩效设置");
    },
    setPermissions(row) {
      Object.assign(this.modalData, row || {});
      this.$refs.setPermissionsModal.open("销售总监权限设置");
    }
  },
  mounted() {}
};
</script>

<template>
  <div class="setting">
    <el-button type="text" size="small" @click="setPermissions()"
      >权限
    </el-button>
    <customTable
      ref="customTable"
      :api="undefined"
      :params="form"
      :isMounted="false"
      :showPagination="false"
    >
      <template #columns>
        <el-table-column
          type="index"
          :index="indexMethod"
          label="序号"
          width="50"
          fixed="left"
        >
        </el-table-column>
        <el-table-column prop="userName" label="成员类型"></el-table-column>
        <el-table-column prop="partnerNum" label="开卡奖励"></el-table-column>
        <el-table-column prop="userName" label="个人绩效比例"></el-table-column>
        <el-table-column
          prop="partnerNum"
          label="团队绩效比例"
        ></el-table-column>

        <el-table-column fixed="right" label="操作" width="120">
          <template #default="{row}">
            <el-button type="text" size="small" @click="setPersonnel(row)"
              >人员
            </el-button>
            <el-button type="text" size="small" @click="setPerformance(row)"
              >绩效
            </el-button>
            <el-button type="text" size="small" @click="setPermissions(row)"
              >权限
            </el-button>
          </template>
        </el-table-column>
      </template></customTable
    >
    <customModal
      ref="setPersonnelModal"
      path="views/teamperformance/components/setPersonnel"
      :footer="true"
      width="620px"
    >
    </customModal>
    <customModal
      ref="setPerformanceModal"
      path="views/teamperformance/components/setPerformance"
      center
      :footer="true"
      width="600px"
    >
    </customModal>
    <customModal
      ref="setPermissionsModal"
      path="views/teamperformance/components/setPermissions"
      center
      :footer="true"
      width="600px"
    >
    </customModal>
  </div>
</template>

<style scoped lang="scss"></style>
